import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col, Card, Modal, Button, message } from 'antd';
import { Animated } from "react-animated-css";
import { GlobalOutlined, PlusOutlined } from '@ant-design/icons';

import DomainOverview from '../../../components/traffic/DomainOverview';
import EndpointManagementModal from '../../../components/traffic/EndpointManagementModal';
import AddDomainModal from '../../../components/traffic/AddDomainModal';

import './TrafficManagement.scss';

// 模擬數據
const mockDomains = [
  {
    id: 1,
    domain: 'www.example.com',
    status: 'active',
    endpoints: 3,
    totalTraffic: '1.2M',
    lastUpdated: '2025-04-03 15:30:00'
  },
  // ... 更多域名數據
];

const mockEndpoints = [
  {
    id: 1,
    name: 'AWS-Singapore',
    type: 'CDN',
    provider: 'AWS',
    region: 'ap-southeast-1',
    status: 'healthy',
    trafficWeight: 40,
    responseTime: '85ms'
  },
  // ... 更多端點數據
];

class TrafficManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDomain: null,
      loading: false,
      domains: mockDomains,
      endpoints: mockEndpoints,
      isEndpointModalVisible: false,
      isAddDomainModalVisible: false,
      addDomainLoading: false,
    };
  }

  handleDomainSelect = (domainId) => {
    this.setState({ 
      selectedDomain: domainId,
      isEndpointModalVisible: true 
    });
    // 這裡之後會調用 API 獲取該域名的端點數據
  }

  handleModalClose = () => {
    this.setState({ isEndpointModalVisible: false });
  }

  handleEndpointWeightChange = (endpointId, weight) => {
    // 更新端點權重的邏輯
    const updatedEndpoints = this.state.endpoints.map(endpoint => {
        if (endpoint.id === endpointId) {
            return { ...endpoint, trafficWeight: weight };
        }
        return endpoint;
    });
      
    this.setState({ endpoints: updatedEndpoints });
  }

  handleWeightSave = () => {
    // 保存權重變更到後端
    message.success('Traffic distribution updated successfully');
    this.handleModalClose();
  }

  handleAddDomainClick = () => {
    this.setState({ isAddDomainModalVisible: true });
  };
  
  handleAddDomainCancel = () => {
    this.setState({ isAddDomainModalVisible: false });
  };
  
  handleAddDomain = async (values) => {
    this.setState({ addDomainLoading: true });
    try {
      // 這裡添加創建域名的 API 調用
      console.log('Adding domain:', values);
      // 模擬 API 調用
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      message.success('Domain added successfully');
      this.setState({ isAddDomainModalVisible: false });
    } catch (error) {
      message.error('Failed to add domain');
    } finally {
      this.setState({ addDomainLoading: false });
    }
  };

  render() {
    const { 
        loading, 
        domains, 
        endpoints, 
        selectedDomain,
        isEndpointModalVisible 
    } = this.state;

    const selectedDomainData = domains.find(d => d.id === selectedDomain);

    return (
        <Animated animationIn="fadeIn">
            <div className="traffic-management">
            <Row gutter={[16, 16]}>
                <Col span={24}>
                <Card 
                    title="Domain Overview" 
                    extra={
                    <Button 
                        type="primary" 
                        icon={<PlusOutlined />}
                        onClick={this.handleAddDomainClick}
                    >
                        Add Domain
                    </Button>
                    }
                >
                    <DomainOverview 
                    loading={loading}
                    domains={domains}
                    onDomainSelect={this.handleDomainSelect}
                    />
                </Card>
                </Col>
            </Row>

            <EndpointManagementModal
                visible={isEndpointModalVisible}
                domain={selectedDomainData}
                loading={loading}
                endpoints={endpoints}
                onCancel={this.handleModalClose}
                onWeightChange={this.handleEndpointWeightChange}
                onSave={this.handleWeightSave}
            />

            <AddDomainModal
                visible={this.state.isAddDomainModalVisible}
                loading={this.state.addDomainLoading}
                onCancel={this.handleAddDomainCancel}
                onAdd={this.handleAddDomain}
            />
            
            </div>
        </Animated>
    );
  }
}

const mapStateToProps = state => ({
  userProfile: state.user.userProfile,
  selectedOrganization: state.user.selectedOrganization
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      // 之後會加入 action creators
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(TrafficManagement);
